module.exports = __webpack_public_path__ + "media/images/badges/purebarre/PureBarre-5000-Classes-Active-a3f841eef210f192d0b20581d253b3d7.png";